const UserNotificationEventType = {
  View: 'View',
  Click: 'Click',
  Dismiss: 'Dismiss',
} as const;

type UserNotificationEventType = (typeof UserNotificationEventType)[keyof typeof UserNotificationEventType];

export { UserNotificationEventType };
